const AdIdentifiers = ['utm', 'drivably'];
const StorageKey = 'drvtrd-utm-data';

/** Persist ad url query across pages and session for submission on form submit */
export const saveAdsParamFromUrl = () => {
  const urlQuery = document.location.search;
  if (AdIdentifiers.every((identified) => urlQuery.includes(identified))) {
    localStorage.setItem(StorageKey, urlQuery);
  }
};

/** Retrieve stored ad url query */
export const getAdsParam = () => localStorage.getItem(StorageKey);

/** Clear stored ad url query */
export const clearAdsParam = () => localStorage.removeItem(StorageKey);
